import { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { RETENTLY_TRACKING_ID } from 'shared/config'
import { useEntitiesContext } from 'entities/EntitiesExport'

export const RetentlyLayout = observer(() => {
  const { usersStore, organizationStore } = useEntitiesContext()
  const { name: organizationName, id: organizationId } = organizationStore

  useEffect(() => {
    if (!usersStore.user) return

    const id = 'retently-jssdk'
    const js = document.createElement('script')
    const rjs = document.getElementsByTagName('script')[0]

    js.id = id
    js.src = 'https://cdn.retently.com/public/components/embed/sdk.min.js'

    rjs?.parentNode?.insertBefore(js, rjs)
  }, [usersStore.user, RETENTLY_TRACKING_ID])

  useEffect(() => {
    if (!usersStore.user || !RETENTLY_TRACKING_ID) return

    const { first_name, last_name, email, id: userId } = usersStore.user
    const embedElement = document.querySelector('#retently-survey-embed')

    if (embedElement) {
      embedElement.setAttribute('data-email', email)
      embedElement.setAttribute('data-firstname', first_name)
      embedElement.setAttribute('data-lastname', last_name)
      embedElement.setAttribute('data-company', organizationName ? organizationName : '')
      embedElement.setAttribute(
        'data-prop-organization_id',
        organizationId ? String(organizationId) : ''
      )
      embedElement.setAttribute('data-prop-user_id', userId ? String(userId) : '')

      return
    }

    const div = document.createElement('div')

    div.id = 'retently-survey-embed'
    div.setAttribute(
      'data-href',
      `https://app.retently.com/api/remote/tracking/${RETENTLY_TRACKING_ID}`
    )
    div.setAttribute('data-rel', 'dialog')
    div.setAttribute('data-campaign', 'regular')
    div.setAttribute('data-email', email)
    div.setAttribute('data-firstname', first_name)
    div.setAttribute('data-lastname', last_name)
    div.setAttribute('data-company', organizationName ? organizationName : '')
    div.setAttribute('data-prop-organization_id', organizationId ? String(organizationId) : '')
    div.setAttribute('data-prop-user_id', userId ? String(userId) : '')

    document.body.appendChild(div)
  }, [usersStore.user, organizationName, organizationId, RETENTLY_TRACKING_ID])

  return null
})
